import * as React from 'react';
import styled from "styled-components";
import TabBar, {TabBarItem} from "./TabBar";
import TextContentBox from "./TextContentBox";
import TabletSlider from "./TabletSlider";
import ImageCourse1 from '../../../images/for-teachers/courses-1.jpg'
import ImageCourse2 from '../../../images/for-teachers/courses-2.jpg'
import ImageCourse3 from '../../../images/for-teachers/courses-3.jpg'
import ImageCourseCreate1 from '../../../images/for-teachers/courses-create-1.jpg'
import ImageCourseCreate2 from '../../../images/for-teachers/courses-create-2.jpg'
import ImageTasks1 from '../../../images/for-teachers/tasks-1.jpg'
import ImageTasks2 from '../../../images/for-teachers/tasks-2.jpg'
import ImageLessons1 from '../../../images/for-teachers/lessons-1.png'
import ImageLessons2 from '../../../images/for-teachers/lessons-2.jpg'
import ImageWebinars1 from '../../../images/for-teachers/webinars-1.jpg'
import ImageWebinars2 from '../../../images/for-teachers/webinars-2.jpg'
import ImagePayments1 from '../../../images/for-teachers/payments-1.jpg'
import ImagePayments2 from '../../../images/for-teachers/payments-2.jpg'
import ImageStudents1 from '../../../images/for-teachers/students-1.jpg'
import ImageStudents2 from '../../../images/for-teachers/students-2.jpg'
import ImageLibrary1 from '../../../images/for-teachers/library-1.jpg'
import ImageLibrary2 from '../../../images/for-teachers/library-2.jpg'

const List = styled.ol`
  list-style: none;
  counter-reset: item;
  padding: 0;
  margin: 0;
`

const ListItem = styled.li`
  counter-increment: item;
  
  &::before {
    content: counter(item) ". ";
    font-weight: 700;
  }
`

const TabContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 357px 760px;
  gap: 40px;
`

const Container = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: 1270px) {
    ${TabContainer} {
      grid-template-columns: 357px 1fr;
    }
  }

  @media screen and (max-width: 1140px) {
    ${TabContainer} {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`;

/**
 * render landing page teacher functional block
 * @constructor
 */
export default function FunctionalTeachers(): React.ReactElement {
  const [activeTab, setActiveTab] = React.useState(1)

  const tabs: TabBarItem[] = [
    {num: 1, label: 'Курсы'},
    {num: 2, label: 'Создание курса'},
    {num: 3, label: 'Задания'},
    {num: 4, label: 'Уроки'},
    {num: 5, label: 'Трансляции'},
    {num: 6, label: 'Оплаты'},
    {num: 7, label: 'Студенты'},
    {num: 8, label: 'Библиотека'},
  ];

  function renderTabContent() {
    switch (activeTab) {
      case 1:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Удобные карточки
                с сортировкой по папкам
                и удобным поиском с быстрыми действиями:
              </div>
              <List>
                <ListItem>Быстрая публикация и снятие с публикации</ListItem>
                <ListItem>
                  Редактирование, копирование
                  и удаление в корзину
                </ListItem>
                <ListItem>Создание ссылки лендинга/приглашения</ListItem>
                <ListItem>Список студентов</ListItem>
                <ListItem>Быстрое добавление студента</ListItem>
              </List>
              <div>
                Настраивайте вид,
                организуйте порядок
                и следите за главными показателями с одного экрана.
              </div>
              <div>
                Больше не нужно долго искать нужный курс:
                настраивайте фильтры,
                теги и работаете с поиском как это удобно Вам!
              </div>
            </TextContentBox>
            <TabletSlider
              items={[
                ImageCourse1,
                ImageCourse2,
                ImageCourse3,
              ]}
            />
          </TabContainer>
        );
      case 2:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Устанавливайте свои правила в несколько кликов:
              </div>
              <List>
                <ListItem>
                  Привязанные к дате
                  марафоны или курсы
                  со свободной датой старта
                </ListItem>
                <ListItem>
                  Настраиваете усилители продаж:
                  повторные продажи,
                  специальные предложения,
                  промо-коды,
                  курсы в подарок и кросс-селлы.
                </ListItem>
                <ListItem>
                  Добавляйте содержание из
                  готовых уроков или создавайте
                  все в одном окне,
                  перетаскивайте, копируйте, удаляйте!
                </ListItem>
                <ListItem>
                  Добавляйте студентов: списком,
                  по одному,
                  открывайте и закрывайте доступ
                  как удобно Вам!
                </ListItem>
                <ListItem>
                  Назначьте своих кураторов
                  и администраторов
                  с разными правами доступа
                </ListItem>
              </List>
            </TextContentBox>
            <TabletSlider
              items={[
                ImageCourseCreate1,
                ImageCourseCreate2,
              ]}
            />
          </TabContainer>
        );
      case 3:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Занимайтесь творческими процессами
                и созданием контента,
                всю рутину - мы берем на себя:
              </div>
              <List>
                <ListItem>Автоматизация проверки заданий</ListItem>
                <ListItem>Уникальная система скоринга</ListItem>
                <ListItem>
                  Быстрое создание карточек заданий,
                  выбирайте любой из 6 форматов
                </ListItem>
                <ListItem>
                  Просматривайте ответы
                  и добавляйте комментарии
                </ListItem>
                <ListItem>Настройки доступа и таймер прохождения</ListItem>
              </List>
              <div>
                Все удобном интерфейсе и в одном окне.
              </div>
            </TextContentBox>
            <TabletSlider
              items={[
                ImageTasks1,
                ImageTasks2,
              ]}
            />
          </TabContainer>
        );
      case 4:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Такой-же удобный менеджемент
                и создания уроков, с тэгами,
                поиском и демонстрацией где используется урок.
                Вы точно теперь не запутаетесь.
              </div>
              <List>
                <ListItem>
                  Создавайте уроки из готовых блоков:
                  мощный текстовый редактор,
                  изображения, видео, галлерея, документы.
                </ListItem>
                <ListItem>
                  Быстрое и удобное добавление
                  материалов из библиотеки
                </ListItem>
                <ListItem>
                  Автоматическое оформление
                  в красивую верстку для вашего пользователя
                </ListItem>
                <ListItem>
                  Удобное расписание
                  и интуитивно-понятная навигация для студента
                </ListItem>
              </List>
            </TextContentBox>
            <TabletSlider
              items={[
                ImageLessons1,
                ImageLessons2,
              ]}
            />
          </TabContainer>
        );
      case 5:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Проводите трансляции
                без ограничений по времени и количеству человек,
                используя встроенный функционал трансляций
                для вебинаров по технологии WebRTC:
                Отличное качество связи и стабильность.
              </div>
              <List>
                <ListItem>
                  Задавайте настройки трансляции
                  и время проведения,
                  добавляйте материалы для проведения
                </ListItem>
                <ListItem>
                  Используйте большой встроенный функционал
                  - есть все, что нужно!
                </ListItem>
                <ListItem>
                  Делайте специальные офферы во время трансляции,
                  предложение появится на экране участника,
                  а также в личном кабинете после трансляции,
                  если вы этого захотите.
                </ListItem>
              </List>
            </TextContentBox>
            <TabletSlider
              items={[
                ImageWebinars1,
                ImageWebinars2,
              ]}
            />
          </TabContainer>
        );
      case 6:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Функциональная и удобный раздел оплат:
              </div>
              <List>
                <ListItem>
                  Информативная аналитика поступлений,
                  среднего чека,
                  повторных продаж и транзакций.
                </ListItem>
                <ListItem>Удобные фильтры и поиск</ListItem>
                <ListItem>Список транзакций и контактов</ListItem>
                <ListItem>
                  Редактирование и настройка платежей
                  для одного пользователя с возможностью
                  специальных предложений и рассрочек
                </ListItem>
              </List>
            </TextContentBox>
            <TabletSlider
              items={[
                ImagePayments1,
                ImagePayments2,
              ]}
            />
          </TabContainer>
        );
      case 7:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Управление отношениями с пользователями из одного окна:
              </div>
              <List>
                <ListItem>
                  Просматривайте историю студента
                  и взаимодействия с вашей школой
                </ListItem>
                <ListItem>
                  Приглашайте студентов на курс и проверяйте домашние задания
                </ListItem>
              </List>
            </TextContentBox>
            <TabletSlider
              items={[
                ImageStudents1,
                ImageStudents2,
              ]}
            />
          </TabContainer>
        );
      case 8:
        return (
          <TabContainer>
            <TextContentBox
              title={tabs[activeTab-1].label}
              number={activeTab}
            >
              <div>
                Удобное облачное хранилище
                для всех ваших файлов,
                всегда под рукой,
                с любого устройства!
              </div>
              <List>
                <ListItem>
                  Добавляйте один из типов файлов:
                  Изображения, видео, документы
                </ListItem>
                <ListItem>Используйте удобный поиск</ListItem>
                <ListItem>Используйте файлы при создании контента</ListItem>
              </List>
            </TextContentBox>
            <TabletSlider
              items={[
                ImageLibrary1,
                ImageLibrary2,
              ]}
            />
          </TabContainer>
        );
    }
  }

  return (
    <Container>
      <TabBar
        active={activeTab}
        items={[...tabs]}
        onChange={(tab) => setActiveTab(tab)}
      >
        {renderTabContent()}
      </TabBar>
    </Container>
  );
}
